module.exports = __webpack_public_path__ + "fonts/Montserrat-Light.100b38f.ttf";